import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { GeneralService } from 'src/app/shared/services/general.service';

@Component({
    selector: 'app-shares',
    templateUrl: './shares.component.html',
    styleUrls: ['./shares.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SharesComponent implements OnInit {

    constructor(
        public gs: GeneralService) {

    }

    ngOnInit() {
    }

}
